import { render, staticRenderFns } from "./CreateCompanyUser.vue?vue&type=template&id=d6550090&"
import script from "./CreateCompanyUser.vue?vue&type=script&lang=js&"
export * from "./CreateCompanyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports